<template>
  <div>
        <van-uploader style="margin:20px"  :after-read="afterRead">
          <template #preview-cover="{ file }">
            <div class="preview-cover van-ellipsis">{{ file.name }}</div>
          </template>
        </van-uploader>
        <!-- v-model="imageList" -->
<div style="padding:15px">
  <van-image style="padding:5px" v-for="(item,index) in imageList" :key="index" width="450" height="450" :src="item.url"/>
</div>

        <van-tabbar v-model="active">
          <van-tabbar-item name="servis" to="/servis" icon="wap-home-o">Servis</van-tabbar-item>
          <van-tabbar-item name="detay" :to="`/servis/${id*8589}`" icon="home-o">Genel</van-tabbar-item>
          <van-tabbar-item name="islem" :to="`/islem/${id*8589}`" icon="notes-o">İşlem</van-tabbar-item>
          <van-tabbar-item name="stok" :to="`/stok/${id*8589}`" icon="points">Stok</van-tabbar-item>
          <van-tabbar-item name="matbuu" :to="`/matbuu/${id*8589}`" icon="photo-o">Matbuu</van-tabbar-item>
          <van-tabbar-item name="cihaz" :to="`/cihaz/${id*8589}`" icon="fire-o">Cihaz</van-tabbar-item>
        </van-tabbar>
        <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';

export default {
  data() {
    return {
      id:this.$route.params.id/8589,
      imageList: [],
      fileList:[],
      active:'matbuu',
      show:false
    };
  },
  created(){this.getPostsAsync();},

  methods: {
      getPostsAsync(){
        this.imageList = []
            this.$request.get("servis/matbuu/"+this.id)
            .then(res => {
              
              res.results.forEach(element => {
                //console.log(element)
                  this.imageList.push(
                    {
                      url:this.$request.domain+'upload/'+element.image
                    }
                  )
                  console.log(this.imageList)
              });
            })  
      },
      afterRead(file) {
        this.show = true;
        Toast("Lütfen Bekleyiniz")
        this.upload(file)
        .then(res => {
          let data = {
             id:this.id,
             image:res
           }
           this.$request.post("servis/matbuu",data)
           .then(res => {
             this.show = false;
             Toast("Yükleme Başarılı")
           })
           .catch (err => {
             Toast("Dosya Kayıt Edilemedi")
           })
        })
        .catch(err => {
          Toast("Upload Hatası")
        })
      },
      upload(file){
        return new Promise ((resolve,reject) =>{
          let data = {image:file.content}
          this.$request.post("servis/upload",data)
          .then(res => {
            resolve(res.url)
          })
          .catch(err => { reject(err)
          })
        })
      },
  },
};
</script>
<style>
  .preview-cover {
    position: absolute;
    box-sizing: border-box;
    bottom: 0;
    width: 100%;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
  }
</style>


// WEBPACK FOOTER //
// src/components/servis/matbuu.vue